import React from 'react'

import useStyles from './styles'

type YoutubeEmbedProps = {
  embedID: string
  isYours: boolean
}

const YoutubeEmbed: React.FC<YoutubeEmbedProps> = ({ embedID, isYours }) => {
  const classes = useStyles({ isYours })

  return (
    <div className={classes.root}>
      <div className={classes.holder}>
        <iframe
          title='YouTube video player'
          src={`https://www.youtube.com/embed/${embedID}`}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          width='500px'
          height='250px'
          allowFullScreen
          className={classes.frame}
        />
      </div>
    </div>
  )
}

export default YoutubeEmbed
